import React from 'react';
import PropTypes from 'prop-types';
import { Avatar } from '@material-ui/core';
import { useSelector } from "react-redux";
import { getStaffByGuid } from '../../../../redux/selectors/scheduleAttendantSelectros'

const StaffAvatar = props => {
    const { guid } = props;
    
    const staff = useSelector(getStaffByGuid(guid));


    return (<>
        <Avatar alt={staff?staff.name:""} src={staff?"./images/avatars/"+staff.src:""} />
    </>);
}

StaffAvatar.propTypes = {
    guid: PropTypes.string
};


export default StaffAvatar;